module.exports = __webpack_public_path__ + "img/Dantam Makeover 04.8127a5e4.jpg";